import { type Address, type ValidAddress } from '@/features/account/services/Addresses/types'
import { useGuestParams } from '@/features/account/services/GuestUser/hooks'
import { useUser, useZipForZipOnlySignedInUser } from '@/features/account/services/User/hooks'
import { getDefaultShoppingAddressWithUser } from '@/features/account/services/User/utils'

export const useGlobalDefaultShoppingAddress = (): ValidAddress | Address => {
  const defaultShoppingAddress = useDefaultShoppingAddress()
  const { guestAddress } = useGuestParams() ?? {}
  const zipForZipOnlyUser = useZipForZipOnlySignedInUser()
  if (zipForZipOnlyUser) {
    return { zip_code: zipForZipOnlyUser }
  }
  return guestAddress?.zip_code ? guestAddress : defaultShoppingAddress
}

export const useAddresses = (): Address[] => useUser()?.customer_addresses ?? []

// the default shopping address is derived directly from the user
// data, which is the single source of truth for address data.
// note that non-null assertion for defaultAddress is used
// because it is theoretically impossible for it to be null.
// except at the stage of first sign up, which is handled in
// useGlobalDefaultShoppingAddress hook.
export const useDefaultShoppingAddress = (): Address => {
  const user = useUser()
  const defaultAddress = (user && getDefaultShoppingAddressWithUser(user))!
  // this can be falsy due to the non-null assertion above
  // oxlint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return defaultAddress || {}
}

export const useDeliveryInstructions = (): string =>
  useDefaultShoppingAddress().delivery_instructions ?? ''
